// test2704
(2704 && 0);
